<template>
  <div class="v-btn__content--wrap" data-qa="wrappedbutton-div-g30ele">
    <v-btn
      @click="$emit('click')"
      outlined
      class="text-none white--text py-2 px-4"
       data-qa="wrappedbutton-btn-s1eqxb"> {{ text }}
    </v-btn>
  </div>
</template>

<script>
export default {
  props: ['text']
}
</script>

<style scoped>
.v-btn__content--wrap >>> span.v-btn__content {
  white-space: normal;
  flex: auto;
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
}
</style>
